import { render, staticRenderFns } from "./StudentAttendanceReport.vue?vue&type=template&id=2c53aaca"
import script from "./StudentAttendanceReport.vue?vue&type=script&lang=js"
export * from "./StudentAttendanceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports